<template>
    <div class="app-container">
        <div class="filter-head">
            <div>
                <el-button type="primary" @click="handleAddTable">新增</el-button>
                <el-button type="warning" :loading="listLoading" icon="el-icon-upload2"
                    @click="exportExcel">导出Excel</el-button>
            </div>
            <div class="status-filter">
                <div class="select">
                    <el-input v-model="listQuery.name" placeholder="分类名称"></el-input>
                </div>
                <div class="select">
                    <el-select v-model="listQuery.type" placeholder="测评类型" clearable>
                        <el-option label="产品体验" :value="1" />
                        <el-option label="探店体验" :value="2" />
                    </el-select>
                </div>
                <div class="select">
                    <el-select v-model="listQuery.state" placeholder="状态" clearable>
                        <el-option label="正常" :value="1" />
                        <el-option label="下架" :value="0" />
                    </el-select>
                </div>
                <el-button type="primary" icon="el-icon-search" :loading="listLoading" @click="handleFilter">搜索</el-button>
            </div>
        </div>
        <div class="table">
            <el-table v-loading="listLoading" element-loading-text="Loading" :data="tableData" border fit
                highlight-current-row>
                <el-table-column type="index" label="序号" width="95" align="center" />
                <el-table-column prop="name" label="分类" min-width="110" align="center" />
                <el-table-column label="类型" min-width="110" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.type === 1">产品体验</span>
                        <span v-else-if="scope.row.type === 2">探店体验</span>
                    </template>
                </el-table-column>
                <el-table-column prop="state" label="状态" min-width="110" align="center">
                    <template slot-scope="scope">
                        <el-tag v-if="(scope.row.state === 1)" type="success">
                            正常
                        </el-tag>
                        <el-tag v-else type="warning">
                            下架
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="230" align="center" fixed="right">
                    <template slot-scope="scope">
                        <!-- <el-button size="mini" type="primary" @click="handleEditTable(scope.row)">编辑</el-button> -->

                        <el-button v-if="scope.row.state === 1" type="warning" size="mini"
                            @click="handleForbid(scope.row.id, '下架')">下架</el-button>

                        <el-button v-else-if="scope.row.state === 0" size="mini" type="success"
                            @click="handleForbid(scope.row.id, '上架')">上架
                        </el-button>

                        <el-popconfirm title="确定删除?" @confirm="handleDeleteTable(scope.row.id)"   @onConfirm="handleDeleteTable(scope.row.id)">
                            <el-button type="danger" slot="reference" size="mini" style="margin-left:10px;">删除
                            </el-button>
                        </el-popconfirm>
                    </template>
                </el-table-column>
            </el-table>

            <div class="pagination-container">
                <el-pagination :current-page="listQuery.page" :page-sizes="[10, 20, 30, 50]" :page-size="listQuery.limit"
                    :total="total" background layout="total, sizes, prev, pager, next, jumper"
                    @size-change="handleSizeChange" @current-change="handleCurrentChange" />
            </div>
        </div>

        <TableActionModal :show.sync="visible" :type="modalType" :edit-data="editData"
            @onUpdate="onTableActionModalSubmit" />
    </div>
</template>

<script>
import { productCategoriesList, changeState, delEvent } from "@/api/basic"
import TableActionModal from './components/TableActionModal.vue';
import * as XLSX from "xlsx"

export default {
    data: () => ({
        listLoading: false,
        tableData: [],
        total: null,
        listQuery: {
            page: 1,
            limit: 10,
            name: '',
            type: null,
            state: null
        },
        modalType: 'add',
        visible: false,
        editData: null
    }),
    components: {
        TableActionModal
    },
    methods: {
        getList() {
            this.listLoading = true
            productCategoriesList(this.listQuery).then(({ data }) => {
                this.tableData = data.data
                this.total = data.total
                this.listLoading = false
            })
        },
        handleFilter() {
            this.listQuery.page = 1
            this.getList()
        },
        // 表格操作
        handleEditTable(e) {
            this.setModalType('edit')
            this.editData = e
            this.visible = true
        },
        handleForbid(id, text) {
            this.$confirm("此操作将" + text + "该分类, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                changeState(id).then(() => {
                    this.getList()
                    this.$message({
                        message: '操作成功!',
                        type: 'success'
                    });
                }).catch(() => { this.$message.error('操作失败!'); })
            })
        },
        async handleDeleteTable(id) {
            try {
                await delEvent(id)
                this.getList()
                this.$message({
                    message: '已删除该分类!',
                    type: 'success'
                });
            } catch {
                this.$message.error('操作失败!');
            }
        },
        // 分页操作
        handleSizeChange(limit) {
            this.listQuery.limit = limit
            this.getList()
        },
        handleCurrentChange(page) {
            this.listQuery.page = page
            this.getList()
        },
        // 更改模式
        setModalType(type) {
            this.modalType = type
        },
        // 添加数据
        handleAddTable() {
            this.setModalType('add')
            this.visible = true
        },
        onTableActionModalSubmit() {
            this.getList()
        },
        // 导出Excel
        async exportExcel() {
            console.log('exportExcel')

            const { total } = this
            if (!total) return

            try {
                const { data: { data: reqData } } = await productCategoriesList({ ...this.listQuery, page: 1, limit: total })
                console.log(reqData);

                var wb = XLSX.utils.book_new();

                var excelData = [
                    ['序号', '分类', '类型', '状态'],
                    ...reqData.map((item, index) => [
                        index + 1, item.name, item.type === 1 ? '产品体验' : item.type === 2 ? '探店体验' : '无字段', item.state ? '正常' : '下架'
                    ])
                ];
                var ws = XLSX.utils.aoa_to_sheet(excelData);
                XLSX.utils.book_append_sheet(wb, ws, "测评商品分类");
                XLSX.writeFile(wb, "测评商品分类.xlsx");

                this.$notify.info({
                    title: '消息',
                    message: '请等待, 正在生成Excel表格文件...'
                });
            } catch {
                this.$notify.error({
                    title: '错误',
                    message: '获取数据错误!'
                });
            }
        }
    },
    created() {
        this.getList()
    }
}
</script>

<style scoped lang="scss">
.filter-head {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .status-filter {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .select {
            margin-right: 8px;
        }
    }
}

.table {
    margin-top: 10px;
}
</style>